import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest } from '@polkadot/x-rxjs';
import { map } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs"; // Voter is current tuple is 2.x-era

function isVoter(value) {
  return !Array.isArray(value);
}

function retrieveStakeOf(api) {
  return (api.query.electionsPhragmen || api.query.elections).stakeOf.entries().pipe(map(function (entries) {
    return entries.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          _ref2$0$args = _slicedToArray(_ref2[0].args, 1),
          accountId = _ref2$0$args[0],
          stake = _ref2[1];

      return [accountId, stake];
    });
  }));
}

function retrieveVoteOf(api) {
  return (api.query.electionsPhragmen || api.query.elections).votesOf.entries().pipe(map(function (entries) {
    return entries.map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          _ref4$0$args = _slicedToArray(_ref4[0].args, 1),
          accountId = _ref4$0$args[0],
          votes = _ref4[1];

      return [accountId, votes];
    });
  }));
}

function retrievePrev(api) {
  return combineLatest([retrieveStakeOf(api), retrieveVoteOf(api)]).pipe(map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        stakes = _ref6[0],
        votes = _ref6[1];

    var result = [];
    votes.forEach(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 2),
          voter = _ref8[0],
          votes = _ref8[1];

      result.push([voter, {
        stake: api.registry.createType('Balance'),
        votes: votes
      }]);
    });
    stakes.forEach(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          staker = _ref10[0],
          stake = _ref10[1];

      var entry = result.find(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 1),
            voter = _ref12[0];

        return voter.eq(staker);
      });

      if (entry) {
        entry[1].stake = stake;
      } else {
        result.push([staker, {
          stake: stake,
          votes: []
        }]);
      }
    });
    return result;
  }));
}

function retrieveCurrent(api) {
  var elections = api.query.electionsPhragmen || api.query.elections;
  return elections.voting.entries().pipe(map(function (entries) {
    return entries.map(function (_ref13) {
      var _ref14 = _slicedToArray(_ref13, 2),
          _ref14$0$args = _slicedToArray(_ref14[0].args, 1),
          accountId = _ref14$0$args[0],
          value = _ref14[1];

      return [accountId, isVoter(value) ? {
        stake: value.stake,
        votes: value.votes
      } : {
        stake: value[0],
        votes: value[1]
      }];
    });
  }));
}

export function votes(instanceId, api) {
  return memo(instanceId, function () {
    return (api.query.electionsPhragmen || api.query.elections).stakeOf ? retrievePrev(api) : retrieveCurrent(api);
  });
}